import { render, staticRenderFns } from "./TooltipRedirect.vue?vue&type=template&id=2019206a&"
import script from "./TooltipRedirect.vue?vue&type=script&lang=js&"
export * from "./TooltipRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports